export default {
  props: {
    /**
     * Texto do chip
     */
    text: {
      type: String,
      required: true,
    },
    /**
     * Ícone adicionado ao chip
     */
    icon: {
      type: String,
      required: false,
      default: null,
    },
    color: {
      type: String,
      required: false,
      default: '',
    },
    /**
     * Para indicar que a cor de fundo é escura
     *
     * (somente quando selected: true)
     */
    dark: {
      type: Boolean,
      required: false,
      default: false,
    },
    /**
     * Flag para deixar o fundo preenchido (selecionado)
     */
    selected: {
      type: Boolean,
      required: false,
      default: false,
    },
    /**
     * Flag para desabilitar o chip
     */
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    /**
     * Flag para indicar que o chip deve ser pequeno
     */
    small: {
      type: Boolean,
      required: false,
      default: false,
    },
    /**
     * Flag para indicar que o chip deve ser bem pequeno
     */
    xSmall: {
      type: Boolean,
      required: false,
      default: false,
    },
    /**
     * Flag para indicar que a cor do icone do chip
     */
    iconColor: {
      type: String,
      default: '',
    },
  },
  computed: {
    appliedColor() {
      return this.selected
        ? this.color || 'primary'
        : this.color || this.$zoox.colors.black600
    },
    appliedIconColor() {
      return this.iconColor
        ? this.iconColor
        : this.selected
        ? this.$zoox.colors.white
        : this.appliedColor
    },
    iconSize() {
      return this.xSmall || this.small ? '16px' : '24px'
    },
    chipClasses() {
      return {
        selected: this.selected,
        small: this.small,
        'x-small': this.xSmall,
        'custom-color': this.color,
        'with-icon': !!this.icon,
        'icon-right': this.iconRight,
      }
    },
  },
}
